import axios from 'axios'
import _ from 'lodash'
import qs from 'qs'
import store from '@/store'
import { v4 as uuidv4 } from 'uuid'

axios.interceptors.request.use(config => {
  config.headers['X-Correlation-ID'] = uuidv4()
  return config
}, error => {
  return Promise.reject(error)
})

function get(endpoint, params, cancelTokenSource) {
  const settings = { params }
  if(cancelTokenSource) {
    settings.cancelToken = cancelTokenSource.token
  }
  return xhr('get', endpoint, settings)
}

function head(endpoint, params) {
  const settings = { params }
  return xhr('head', endpoint, settings)
}

function post(endpoint, data, params = {}, headers = {}, cancelTokenSource) {
  const settings = { data, params, headers }
  if (cancelTokenSource) {
    settings.cancelToken = cancelTokenSource.token
  }
  return xhr('post', endpoint, settings)
}

function put(endpoint, data, params = {}, headers = {}) {
  return xhr('put', endpoint, { data, params, headers })
}

function patch(endpoint, data, params = {}, headers = {}) {
  return xhr('patch', endpoint, { data, params, headers })
}

function deleteRequest(endpoint, params) {
  return xhr('delete', endpoint, { params })
}

function deleteWithBodyRequest(endpoint, data) {
  return xhr('delete', endpoint, { data })
}

function uploadFile(endpoint, file) {
  const formData = new FormData()
  formData.append('file', file, file.name)
  const headers = { 'Content-Type': 'multipart/form-data' }
  return post(endpoint, formData, {}, headers)
}

function xhr(method, endpoint, settings = {}) {
  let url = `${(process.env.VUE_APP_API_BASE_URL || store.getters.clientModel.apiBasePath)}/${endpoint}`
  if (settings.useDeviationEndpoint) {
    url = endpoint
  }
  const defaultSettings = {
    method,
    url,
    params: { useVat: store.getters['ui/useVat'] },
    paramsSerializer: params => qs.stringify(params, { indices: false }),
    headers: generateHeaders()
  }
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode
  if(isIE11) {
    _.set(defaultSettings, 'params.cacheBust', new Date().getTime())
  }
  const requestConfig = _.merge({}, defaultSettings, settings)
  return axios(requestConfig)
}

function createCancellationToken() {
  const cancelTokenSource = axios.CancelToken.source()
  const id = _.uniqueId()
  const result = () => {
    cancelTokenSource.cancel(id)
  }
  result.cancelTokenSource = cancelTokenSource
  return result
}

function isCancellationError(error) {
  return axios.isCancel(error)
}

function generateHeaders() {
  return {
    'RequestVerificationToken': getRequestValidationToken()
  }
}

function getRequestValidationToken() {
  let tokenElement = document.getElementsByName('__RequestVerificationToken')[0]
  return tokenElement && tokenElement.value
}

export default {
  get,
  head,
  post,
  put,
  patch,
  delete: deleteRequest,
  uploadFile,
  createCancellationToken,
  isCancellationError,
  deleteWithBody: deleteWithBodyRequest,
  xhr
}
